export default {
  insertWlVehicleBlacklist: '/ygsjzs/wlVehicleBlacklist/insertWlVehicleBlacklist',
  updateWlVehicleBlacklist: '/ygsjzs/wlVehicleBlacklist/updateWlVehicleBlacklist',
  deleteDataWlVehicleBlacklist: '/ygsjzs/wlVehicleBlacklist/deleteDataWlVehicleBlacklist',
  selectWlVehicleBlacklistByBlacklistId: '/ygsjzs/wlVehicleBlacklist/selectWlVehicleBlacklistByBlacklistId',
  selectWlVehicleBlacklistByPage: '/ygsjzs/wlVehicleBlacklist/selectWlVehicleBlacklistByPage'
}
